// extracted by mini-css-extract-plugin
export default {"container":"Jaa-z","list":"Kaa-z"};